export default __webpack_public_path__ + "static/media/white_princess.cc6b8241.png";